export const WALLET_BALANCER_QUERY_KEYS = {
  all: ['wallet-balancer'] as const,
  lists: () => [...WALLET_BALANCER_QUERY_KEYS.all, 'list'] as const,
  list: (params?: any) => [...WALLET_BALANCER_QUERY_KEYS.lists(), params] as const,
  details: () => [...WALLET_BALANCER_QUERY_KEYS.all, 'detail'] as const,
  detail: (id: number) => [...WALLET_BALANCER_QUERY_KEYS.details(), id] as const,
  transferHistory: () => [...WALLET_BALANCER_QUERY_KEYS.all, 'transfer-history'] as const,
  transferHistoryList: (params: { group_id: number; limit: number; offset: number }) =>
    [...WALLET_BALANCER_QUERY_KEYS.transferHistory(), params] as const,
} as const;

export const WALLET_BALANCER_AUTO_REFRESH_KEYS = {
  transferHistory: (groupId: number) =>
    `wallet-balancer/transfer/history/auto-refresh/${groupId}` as const,
} as const;
